<script setup lang="ts">
  import TopbarOrganism from '@/components/organisms/topbar-organism/TopbarOrganism.vue';
  import TableMolecule from '@/components/molecules/table-molecule/TableMolecule.vue';

  const dataType = 'Group';
</script>

<template>
  <div>
    <TopbarOrganism title="All Groups" />
    <TableMolecule :dataType="dataType" />
  </div>
</template>

<style scoped>
  a {
    text-decoration: none;
  }
</style>
